const THANK_YOU_URL = "/pages/thank-you";

// let SERVER_URL= 'https://8f8e-142-112-67-219.ngrok-free.app/create-draft-order'
let SERVER_URL = "https://rexall-query.software-93f.workers.dev/create-draft-order"
window.checkoutBtn = document.querySelector("[data-custom-checkout]");
console.log("heyyy",checkoutBtn);

async function createDraft(){
  try {
    const cart = await fetch("/cart.js").then((r) => r.json());
    const lineItems = cart.items.map((item) => ({
      variantId: item.variant_id + '',
      quantity: item.quantity,
    }));

    if (!lineItems.length) {
      alert("Your cart is empty.");
      return;
    }

    const payload = {
      customerId: window.customerId + '', // Use the customerId from global JS variable
      lineItems,
      note: "",
    };

    await $app.request('/create-draft-order',
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );
    fetch("/cart/clear")
    window.location.href = THANK_YOU_URL;
    
  } catch (err) {
    console.error("Custom checkout failed:", err);
    checkoutBtn.disabled = false;
  } 
}

if (checkoutBtn){
  console.log('founddd')
  checkoutBtn.addEventListener("click", async (e) => {
    e.preventDefault();
    if (window.location.href.includes('checkout=1')){
      checkoutBtn.disabled = true;
      createDraft()
    } else {
      window.location.href='/cart?checkout=1'
    } 
    
  });

} else {
  console.log('not found')
}
